

/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

function logoSliderSetup() {
  jQuery('.logo-slider .slick-initialized').slick('unslick');

  var $sliderContainer = jQuery('.logo-slider');

  $sliderContainer.each(function () {
    var $container = jQuery(this),
      $slider = $container.find('.slider'),
      $controls = $container.find('.slider-controls'),
      $dots = $container.find('.slider-dots'),
      centerMode = false,
      dots = false,
      infinite = false,
      auto = false,
      slidesToShow;

    // Dots //
    if ($container.hasClass('dots')) {
      dots = true;
    }

    // Infinite //
    if ($container.hasClass('infinite')) {
      infinite = true;
    }

    // Auto //
    if ($container.hasClass('auto')) {
      auto = true;
    }

    // Center Mode //
    if ($container.hasClass('center-mode')) {
      centerMode = true;
    }

    // Change slides to show - depending on screen size
    if (jQuery(window).width() > 1600) {
      slidesToShow = 5;
    } else if (jQuery(window).width() > 1200) {
      slidesToShow = 3;
    } else if (jQuery(window).width() > 767) {
      slidesToShow = 2;
    } else if (jQuery(window).width() < 480) {
      slidesToShow = 1;
    }

    $slider
      .not('.slick-initialized').slick({
        centerMode: centerMode,
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        dots: dots,
        infinite: infinite,
        autoplay: auto,
        autoplaySpeed: 4000,
        appendDots: $dots,
        appendArrows: $controls,
        prevArrow:
          '<a class="slick-prev"><span class="icon"><i class="fal fa-arrow-left"></i></span></a>',
        nextArrow:
          '<a class="slick-next"><span class="icon"><i class="fal fa-arrow-right"></i></span></a>'
      });
  });
}

function typedDeclare() {
  var typed = new Typed('#typed', {
    stringsElement: '#typed-strings',
    typeSpeed: 25,
    backSpeed: 20,
    loop: false,
    contentType: 'html',
  });
}

function fixedNavProduct() {  
  $siteHeader = jQuery('header.site-header').outerHeight();
  $pageHeader = jQuery('.page-header').outerHeight();
  $productNav = jQuery('nav.nav-product').outerHeight();
  $fixedProductNav = $pageHeader + $productNav;

  if ( jQuery('body').hasClass('single-product') || jQuery('body').hasClass('single-service') ) {
    jQuery('header.site-header').addClass('hide-on-load');
  }

  // 
        
  jQuery(window).scroll(function() {
    var scroll = jQuery(window).scrollTop();

    if (scroll > $fixedProductNav) {
      jQuery('header.site-header').removeClass('hide-on-load');
      jQuery('nav.nav-product').addClass('fixed-nav');
    } else {
      jQuery('nav.nav-product').removeClass('fixed-nav');
    }
  });
}

function sliderSetup() {
  jQuery('.slider-container .slick-initialized').slick('unslick');

  var $sliderContainer = jQuery('.slider-container');

  $sliderContainer.each(function () {
      var $container = jQuery(this),
          $slider = $container.find('.slider'),
          $controls = $container.find('.slider-controls'),
          $dots = $container.find('.slider-dots'),
          dots = false,
          infinite = false,
          auto = false
      ;

      // Dots //
      if ($container.hasClass('dots')) {
          dots = true;
      }

      // Infinite //
      if ($container.hasClass('infinite')) {
          infinite = true;
      }

      // Auto //
      if ($container.hasClass('auto')) {
          auto = true;
      }
      $slider
          .not('.slick-initialized').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: dots,
          infinite: infinite,
          autoplay: auto,
          autoplaySpeed: 4000,
          appendDots: $dots,
          appendArrows: $controls,
          prevArrow: '<a class="slick-prev"> Left  </a>',
          nextArrow: '<a class="slick-next"> Right  </a>'
      });
  });
} //setup slider -- function end

function frontPageSlider() {
  jQuery('.front-page-slider .slick-initialized').slick('unslick');

  var $sliderContainer = jQuery('.front-page-slider');

  $sliderContainer.each(function () {
      var $container = jQuery(this),
          $slider = $container.find('.slider'),
          $controls = $container.find('.slider-controls'),
          $dots = $container.find('.slider-dots'),
          dots = false,
          infinite = false,
          auto = false
      ;

      // Dots //
      if ($container.hasClass('dots')) {
          dots = true;
      }

      // Infinite //
      if ($container.hasClass('infinite')) {
          infinite = true;
      }

      // Auto //
      if ($container.hasClass('auto')) {
          auto = true;
      }
      $slider
          .not('.slick-initialized').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: dots,
          infinite: infinite,
          autoplay: auto,
          autoplaySpeed: 4000,
          appendDots: $dots,
          appendArrows: $controls,
          prevArrow: '<a class="slick-prev"> Left  </a>',
          nextArrow: '<a class="slick-next"> Right  </a>'
      });
  });
} //setup slider -- function end

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {

        // "use strict";
        $('.seperator').first().addClass('first-sep');
        $('.seperator').last().addClass('last-sep');

        function extend(a, b) {
          for (var key in b) {
            if (b.hasOwnProperty(key)) {
              a[key] = b[key];
            }
          }
          return a;
        }
        
        function mobilecheck() {
          var check = false;
          (function(a) {
            if (/(android|ipad|playbook|silk|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) { check = true; }
          })(navigator.userAgent || navigator.vendor || window.opera);
          return check;
        }

          var classAPI, hasClass, addClass, toggleClass, removeClass;

          hasClass = function(el, c) {
            return el.classList.contains(c);
          };

          addClass = function(el, c) {
            return el.classList.add(c);
          };

          toggleClass = function(el, c) {
            return el.classList.toggle(c);
          };

          removeClass = function(el, c) {
            return el.classList.remove(c);
          };

          classAPI = {
            // Full names
            hasClass: hasClass,
            addClass: addClass,
            removeClass: removeClass,
            // Short names
            has: hasClass,
            add: addClass,
            remove: removeClass
          };

          function pushMenu(el, trigger, closeTrigger, wrap, contentWrapper) {
            this.el = el;
            this.trigger = trigger;
            this.closeTrigger = closeTrigger;
            this.wrap = wrap;
            this.content = contentWrapper;

            this._init();
          };

          pushMenu.prototype = {
            _init: function() {
              this.open = false;
              this.levels = Array.prototype.slice.call(this.el.querySelectorAll('div.nav-list__level'));
              this.levelTriggers = Array.prototype.slice.call(this.el.querySelectorAll('div.nav-list__link'));

              // event type ( if mobile use touch events )
              this.eventtype = mobilecheck() ? 'touchstart' : 'click';

              // Save the depth
              var self = this;
              this._initEvents();
            },
            _initEvents: function() {
              var self = this;

              this.trigger.addEventListener(this.eventtype, function(ev) {
                ev.stopPropagation();
                ev.preventDefault();

                var wrapperClickFn = function(el) {
                  self._resetMenu();
                  el.removeEventListener(self.eventtype, wrapperClickFn);
                }

                if(self.open) {
                  self._resetMenu();
                } else {
                  self._openMenu();
                  self.content.addEventListener(self.eventtype, function(evt) {
                    if(self.open) {
                      wrapperClickFn(this);
                    }
                  });
                }
              });

              this.closeTrigger.addEventListener(this.eventtype, function(ev) {
                ev.stopPropagation();
                ev.preventDefault();

                console.log("Clicked closing trigger!");

                var wrapperClickFn = function(el) {
                  self._resetMenu();
                  el.removeEventListener(self.eventtype, wrapperClickFn);
                }
                
                if(self.open) {
                  self._resetMenu();
                } else {
                  self._openMenu();
                  self.content.addEventListener(self.eventtype, function(evt) {
                    if(self.open) {
                      wrapperClickFn(this);
                    }
                  });
                }
              });

              this.levelTriggers.forEach(function(el) {
                el.addEventListener(this.eventtype, self._triggerLevel(el));
              });
            },
            _resetMenu: function() {
              classAPI.removeClass(this.wrap, 'menu-active');
              this.open = false;
            },
            _openMenu: function() {
              classAPI.addClass(this.wrap, 'menu-active');
              this.open = true;
            },
            _triggerLevel: function(el) {
              var lvlIndex, trigger;
              trigger = el;
              lvlIndex = Number(el.getAttribute('data-level-index'));
              
              for(var i = 0; i < this.levels.length; i++ ) {
                var lvlEl = this.levels[i];
                if(Number(lvlEl.getAttribute('data-level-index')) === lvlIndex) {
                  if(classAPI.has(lvlEl, 'active')) {
                    classAPI.remove(lvlEl, 'active');
                  } else {
                    classAPI.add(lvlEl, 'active');
                  }
                }
              }
            }
          };

          new pushMenu(
            document.getElementById('nav--mobile'),
            document.getElementById('site-menu__trigger'),
            document.getElementById('mobile-nav-exit'),
            document.getElementById('main'), document.getElementById('site--wrapper')
          );

          /**
           * Load Gallery Lightboxes
           */
          $('a.fl-gallery').featherlightGallery({
            previousIcon: '&#9664;',     /* Code that is used as previous icon */
            nextIcon: '&#9654;',         /* Code that is used as next icon */
            galleryFadeIn: 100,          /* fadeIn speed when slide is loaded */
            galleryFadeOut: 300          /* fadeOut speed before slide is loaded */
          });

          $('.pb--slider').owlCarousel({
            items: 1,
            nav: true
          });

          logoSliderSetup();

          var resizeThreshold;
          $(window).on('resize', function () {
            if (resizeThreshold) {
              clearTimeout(resizeThreshold);
            }
            resizeThreshold = setTimeout(function () {
              setTimeout(function () {
                // Functions
                logoSliderSetup();
  
              }, 100);
            }, 200);
          });
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
        fixedNavProduct();

        $('.feature-block--component__slider').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          arrows: false,
          dots: true,
          adaptiveHeight: true,
        });

        $('.team-member').on('mouseenter', function(e){
          $(this).addClass('active');
        });

        $('.team-member').on('mouseleave', function(e){
          $(this).removeClass('active');
        });

        $('.faq--wrapper .entry-title').on('click', function(e) {
          if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $(this).siblings('.entry-summary').removeClass('active');
          }
          else {
            $(this).addClass('active');
            $(this).siblings('.entry-summary').addClass('active');
          }
        });


        $('.what-is-new-wrapper').on('click', function(e){
          $(this).toggleClass('active');
        });

      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
        $('.hero-slider').slick({
          items: 1,
          dots: false,
          speed: 500,
          arrows: false,
          adaptiveHeight: true
        });

        $(window).scroll(function() {
          var scroll = $(window).scrollTop();
          if (scroll > 200) {
              $("body.home header.site-header").addClass('shadow');
          }
          else {
            $("body.home header.site-header").removeClass('shadow');
          }
      });

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
        // typedDeclare();
        
      }
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

  sliderSetup();
  frontPageSlider();

  var $body = jQuery('body');

  // js-custom-popup-close

  $body
    .on('click', '.js-footer-accordion-trigger' , function(e){
        e.preventDefault();
        if($(this).hasClass('accordion-active')) {
          $(this).removeClass('accordion-active');
          $(this).closest('.footer__subheading').removeClass('accordion-active');
          $accordion = $(this).closest('.accordion');
          $accordion.removeClass('accordion-toggled');
          $accordion.find('.footer__menu').removeClass('content-show');
        } else {
          $(this).addClass('accordion-active');
          $(this).closest('.footer__subheading').addClass('accordion-active');
          $accordion = $(this).closest('.accordion');
          $accordion.addClass('accordion-toggled');
          $accordion.find('.footer__menu').addClass('content-show');
        }
    })
    .on('click', '.js-custom-popup-trigger', function (e) {
      e.preventDefault();
      $trigger = $(this);
      $popupID = $trigger.attr('data-popup-id');
      $('body div.custom-popup#' + $popupID).addClass('active');
    })
    .on('click', '.js-custom-popup-close', function (e) {
      e.preventDefault();
      $trigger = $(this);
      $popupID = $trigger.attr('data-popup-id');
      $('body').find('div.custom-popup#' + $popupID).removeClass('active');
    })
  ;

  $('.mejs').mediaelementplayer({
		pluginPath: "/path/to/shims/",
	// When using jQuery's `mediaelementplayer`, an `instance` argument
	// is available in the `success` callback
		success: function(mediaElement, originalNode, instance) {
			// do things
		}
  });
  
  $('select.fancy-select').selectpicker('');

  //Select picker used for Resources Page
  $('select.category-fancy-select').selectpicker('');

  // Resource Filter
  $('button#search-cat').on('click', function(e) {
    // e.preventDefault();
    $websiteDomain = window.location.hostname;

    $filter = $(this).parent().closest('.cat-filter-btn').prev();
    $dropDown = $filter.find('select.category-fancy-select');
    $selectedOption = $dropDown.find('option:selected').val();
    console.log($selectedOption);
    window.location.href = $selectedOption;


  });

  $('nav.nav--mobile ul.nav-list li.no-link').on('click', function(e) {
    e.preventDefault();
  });

})(jQuery, window); // Fully reference jQuery after this point.
